import React from "react";

//interfaces and helpers
import { IContentImage } from "../../../../interfaces/image/image";
import { getImageAsset } from "../../../../helpers/Images";

//components
import ProgressiveLoadingImage from "../ProgressiveLoadingImage";



const ContentImage = ({className, contentUrl, token, caption}: IContentImage) => {  
    return (
        <div className={`content-image-component ${className ?? ""}`}>
            <div className="content-image-wrapper">
                <img
                    className={`background-content-image-component`}
                    src={getImageAsset(160, contentUrl, token)}
                    alt={""}
                />
                
                <ProgressiveLoadingImage 
                    imageUrl={contentUrl} 
                    maxWidth={600} 
                    token={token}
                />
            </div>
            {caption && <span className="image-caption">{caption}</span>}
        </div>
    );
};

export default ContentImage;
